<div fxLayout="row" fxLayoutAlign="center">
  <h1>Welcome</h1>
</div>
